document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.dropdown-tabs');

  containers.forEach((container) => {
    const dropdown = container.querySelector('.dropdown-tabs-dropdown');
    const button = dropdown.querySelector('button');
    const list = dropdown.querySelector('.dropdown-tablist-container');
    const tabButtons = Array.from(list.querySelectorAll('button'));
    const tabPanelsContainer = dropdown.closest('section').querySelector('.dropdown-tabpanels-container');
    const tabPanels = Array.from(tabPanelsContainer.children);

    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');

    tabButtons.forEach((tabBtn, i) => {
      const tabId = tabBtn.id || `${container.id || 'tabs'}-tab-${i}`;

      tabBtn.setAttribute('role', 'option');
      tabBtn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tabBtn.setAttribute('tabindex', '-1');
      tabBtn.setAttribute('id', tabId);

      if (tabPanels[i]) {
        const panelId = tabPanels[i]?.id || `${tabId}-panel`;

        tabBtn.setAttribute('aria-controls', panelId);

        tabPanels[i].setAttribute('role', 'tabpanel');
        tabPanels[i].setAttribute('tabindex', '0');
        tabPanels[i].setAttribute('aria-labelledby', tabId);
        tabPanels[i].setAttribute('id', panelId);
      }
    });

    function updateSelection(index) {
      tabButtons.forEach((tabBtn, i) => {
        tabBtn.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tabBtn.classList.toggle('selected', i === index);
      });

      const labelSpan = button.querySelector('.dropdown-tabs-dropdown-label');
      if (labelSpan) {
        labelSpan.textContent = tabButtons[index].querySelector('span').textContent;
      }

      tabPanels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if(i !== index){
          panel.setAttribute('inert', 'true');
        }else{
          panel.removeAttribute('inert');
        }
      });
    }

    function openDropdown() {
      dropdown.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      list.classList.remove('hidden');
      list.focus();
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      list.classList.add('hidden');
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    button.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openDropdown();
        tabButtons[0].focus();
      }
    });

    tabButtons.forEach((tabBtn, i) => {
      tabBtn.addEventListener('click', () => {
        updateSelection(i);
        closeDropdown();
        button.focus();
      });
      tabBtn.addEventListener('keydown', (e) => {
        let targetIndex = i;
        if (e.key === 'ArrowDown') {
          targetIndex = (i + 1) % tabButtons.length;
          e.preventDefault();
          tabButtons[targetIndex].focus();
        } else if (e.key === 'ArrowUp') {
          targetIndex = (i - 1 + tabButtons.length) % tabButtons.length;
          e.preventDefault();
          tabButtons[targetIndex].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          updateSelection(i);
          closeDropdown();
          button.focus();
        }
      });
      dropdown.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeDropdown();
          button.focus();
        }
      });
    });

    document.addEventListener('mousedown', (e) => {
      if (!dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    closeDropdown();
    updateSelection(0);
  });
});